<template>
  <button class="cia-button" role="button"
          :title="title" @click="click" :class="[buttonColor, isBig]">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'cia-button',
  props: ['title', 'click', 'color', 'big'],
  computed: {
    buttonColor() {
      return this.color ? `cia-button--${this.color}` : '';
    },
    isBig() {
      return this.big ? 'cia-button--big' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .cia-button {
    border: 2px solid #1976d2;
    color: #1976d2;
    box-sizing: border-box;
    height: 44px;
    font-size: 14px;
    padding: 0 38px;
    text-transform: uppercase;
    border-radius: 22px;
    transition: 250ms all linear;
    &:hover {
      color: #fff;
      background: #1976d2;
    }
    &--big {
      @media (min-width: 550px) {
        height: 56px;
        font-size: 18px;
        border-radius: 28px;
      }
    }
    &--white {
      background: #fff;
      border-color: #fff;
      &:hover {
        background: transparent;
        color: #fff;
      }
    }
    &--blue {
      background: #1976d2;
      border-color: #1976d2;
      color: #fff;
      &:hover {
        opacity: 0.7;
      }
    }
  }
</style>
